import { useCallback, useMemo } from 'react';
export interface IUsePlaySoundProps {
  soundUrl: string | undefined;
  probability?: number; // odds we play the sound - [0, 1] - defaults to 1
  volume?: number; // defaults to 0.4
}

export function usePlaySound(props: IUsePlaySoundProps) {
  const audio = useMemo(() => {
    const _audio = props.soundUrl ? new Audio(props.soundUrl) : null;
    if (_audio) {
      _audio.loop = false;
      _audio.volume = props.volume ?? 0.4;
    }
    return _audio;
  }, [props.soundUrl]);

  const playSound = useCallback(() => {
    if (!audio) {
      return;
    }
    if (Math.random() < (props.probability ?? 1)) {
      audio.play();
    }
  }, [audio]);

  return {
    playSound,
  };
}
